// extracted by mini-css-extract-plugin
export var pchMobileNavigation = "MobileNav-module--pchMobileNavigation--140XA";
export var mobileHeadingWrapper = "MobileNav-module--mobileHeadingWrapper--2ODpa";
export var logo = "MobileNav-module--logo--2B6dW";
export var closeNav = "MobileNav-module--closeNav--3vduz";
export var mobileLinksWrapper = "MobileNav-module--mobileLinksWrapper--twJ9A";
export var linksList = "MobileNav-module--linksList--1JUct";
export var linkItem = "MobileNav-module--linkItem--3CWDt";
export var link = "MobileNav-module--link--J8eRp";